import { combineReducers } from "redux";
import { sidebarStatus } from "./constants";

// action types

export const TOGGLE_LAYOUT_SIDEBAR = "TOGGLE_LAYOUT_SIDEBAR";
export const SHOW_LAYOUT_SIDEBAR = "SHOW_LAYOUT_SIDEBAR";
export const HIDE_LAYOUT_SIDEBAR = "HIDE_LAYOUT_SIDEBAR";

// action creators

export const toggleLayoutSidebar = () => ({
  type: TOGGLE_LAYOUT_SIDEBAR,
});

export const showLayoutSidebar = () => ({
  type: SHOW_LAYOUT_SIDEBAR,
});

export const hideLayoutSidebar = () => ({
  type: HIDE_LAYOUT_SIDEBAR,
});

// selectors

const getModuleData = (state) => state.layout;

export const isSidebarCollapsed = (state) =>
  getModuleData(state).sidebar.status === sidebarStatus.collapsed;
export const isSidebarExpanded = (state) =>
  getModuleData(state).sidebar.status === sidebarStatus.expanded;
export const isSidebarVisible = (state) =>
  getModuleData(state).sidebar.status !== sidebarStatus.hidden;

const mediaQuery = window.matchMedia("(max-width: 1024px)");
// mappings

export const mapStateToPropsLayout = (state) => ({
  isSidebarCollapsed: isSidebarCollapsed(state),
  isSidebarExpanded: isSidebarExpanded(state),
  isSidebarVisible: isSidebarVisible(state),
});

export const mapDispatchToPropsLayout = {
  toggleLayoutSidebar,
  showLayoutSidebar,
  hideLayoutSidebar,
};

// reducers

const sidebarInitialState = {
  status: mediaQuery.matches
    ? sidebarStatus?.collapsed
    : sidebarStatus?.expanded,
};

const sidebarReducer = (state = sidebarInitialState, action) => {
  switch (action.type) {
    case TOGGLE_LAYOUT_SIDEBAR:
      return {
        ...state,
        status:
          state.status === sidebarStatus.collapsed
            ? sidebarStatus.expanded
            : sidebarStatus.collapsed,
      };

    case SHOW_LAYOUT_SIDEBAR:
      return {
        ...state,
        status: sidebarStatus.collapsed,
      };

    case HIDE_LAYOUT_SIDEBAR:
      return {
        ...state,
        status: sidebarStatus.hidden,
      };

    default:
      return state;
  }
};

export default combineReducers({
  sidebar: sidebarReducer,
});
